var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu",class:{ open: _vm.open }},[_c('span',{staticClass:"bit-1"}),_c('span',{staticClass:"bit-2"}),_c('span',{staticClass:"bit-3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }